import { Container, SelectReact } from './styled';

export function SelectList(props) {
    const {
        className,
        options,
        value,
        onChange,
        placeholder,
        defaultValue,
        isLoading,
        isDisabled,
        isSearchable
    } = props;

    return (
        <Container>
            <SelectReact
                className={className}
                value={value}
                options={options}
                onChange={onChange}
                placeholder={placeholder}
                defaultValue={defaultValue}
                isLoading={isLoading}
                isDisabled={isDisabled}
                isSearchable={(!isSearchable) ? false : true}
            />
        </Container>
    );
}